import React from "react";
import style from "./card.module.scss";

function Card({ items }) {
  return (
    <div className={style.cardContainer}>
      <h6>{items.title}</h6>
      <img className="shake-slow" src={items.url} alt={items.title} />
    </div>
  );
}

export default Card;
